import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import { useGetProviderOptions } from "api/queries/quotes/useGetProviderOptions";
import Alert from "components/v2/Alert/Alert";

export default function QuoteRateCardBanner() {
  const { id } = useParams();
  const shipmentId = id!;

  const [showAlert, setShowAlert] = useState(true);

  const { data: providers } = useGetProviderOptions({
    shipmentId,
  });

  const errors = useMemo<string[]>(() => {
    const split = (s?: string | null) => (s ? s.split("\n") : []);

    // 1) collect messages (newline-aware)
    const rawMessages = (providers ?? []).flatMap((provider: any) => [
      ...split(provider.rate_card_error_message),
      ...split(provider.auto_quote_error_message),
    ]);

    return Array.from(new Set(rawMessages.map((msg: any) => msg.trim()).filter((msg: any) => msg.length > 0)));
  }, [providers]);

  const showAlertCondition = errors.length > 0 && showAlert;

  if (!showAlertCondition) return null;

  return (
    <Alert
      variant="warning"
      label=""
      onClose={() => {
        setShowAlert(false);
      }}
    >
      {errors.map((err, index) => (
        <div key={index} className="pr-xl">
          {err}
        </div>
      ))}
    </Alert>
  );
}
